import { requireEnv } from '@/lib/env';
import type { paths } from '@/services/api-allo/api-allo-v1';
import { fetchWithAuth } from '@/services/api-allo/fetch-with-auth';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';

const BASE_URL = import.meta.env.VITE_API_ALLO_URL;

requireEnv('VITE_API_ALLO_URL', BASE_URL);

export const $fetchAllo = createFetchClient<paths>({
  baseUrl: BASE_URL,
  fetch: fetchWithAuth,
});

export const isApiError = (err: unknown): err is { code: string } =>
  typeof err === 'object' && err !== null && 'code' in err && typeof (err as any).code === 'string';

export const $apiAllo = createClient($fetchAllo);
